import { render, staticRenderFns } from "./DuplicateEvent.vue?vue&type=template&id=5b2d8b54&"
import script from "./DuplicateEvent.vue?vue&type=script&lang=js&"
export * from "./DuplicateEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports